import { render } from "./CollapsibleCard.vue?vue&type=template&id=7298e761&scoped=true&ts=true"
import script from "./CollapsibleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleCard.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleCard.vue?vue&type=style&index=0&id=7298e761&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7298e761"],['__file',"resources/js/vue/components/ui/CollapsibleCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7298e761"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7298e761', __exports__)) {
    api.reload('7298e761', __exports__)
  }
  
  module.hot.accept("./CollapsibleCard.vue?vue&type=template&id=7298e761&scoped=true&ts=true", () => {
    api.rerender('7298e761', render)
  })

}


export default __exports__